<app-admin-header [isHideToggleButton]="isExpired || isPWA" (toggleSideBarForMe)="sideBarToggler()"></app-admin-header>

<mat-drawer-container>
  <mat-drawer #drawer mode="side" [opened]="sideBarOpen" *ngIf="!isExpired && !isPartnerPortal">
    <app-admin-sidenav [drawer]="drawer"></app-admin-sidenav>
    <button mat-flat-button *ngIf="!isPWA && showInstallBox && isRetailer" type="button" class="download-app mt-8"
      (click)="InstallPWA()" color="warn">Install App
    </button>
  </mat-drawer>
  <mat-drawer-content>
    <div class="row" *ngIf="!isExpired">
      <router-outlet></router-outlet>
    </div>
    <div class="row heading-content" *ngIf="isExpired">
      <div class="col-sm-12 text-center">
        <h1 class="font-50">Subscribe to enjoy our services</h1>
        <h1>The Right Plan for Your Business</h1>
        <p>We have serveral powerful plan to showcase your business and get discovered as a creative enterpreneurs.
          Everything you need.</p>
        <button mat-flat-button type="button" (click)="openSubscriptionPlanExpired()" color="primary">Choose your plan
        </button>
      </div>
    </div>
    <app-admin-footer></app-admin-footer>
  </mat-drawer-content>
</mat-drawer-container>